

import React from "react";
import Signup from "./pages/Signup";
import { Container } from "react-bootstrap";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import './styles/App.css';
import FirstPage from "./pages/FirstPage";
import Questionnaire from './pages/Questionnaire'
import Help from './pages/Help'

import { Switch, Route, useParams } from "react-router-dom";
import Login from "./pages/Login";
import PrivateRoute from "./components/PrivateRoute";
import ForgotPassword from "./pages/ForgotPassword";
import UpdateProfile from "./pages/UpdateProfile";
import DisplayId from "./pages/DisplayId";
import Dashboard from "./pages/Dashboard";
import UpdateForm from './pages/UpdateForm';

import Result from './pages/Result';

import MainPage from "./features/NewEditor/MainPageDrag";
import FinalResult from "./features/NewEditor/FinalResult";

function App() {
	return (
		<div >

			<div>
	
				<AuthProvider>
					<Switch>
						<PrivateRoute exact path='/firstpage' component={FirstPage} />
						<PrivateRoute exact path='/questionnaire' component={Questionnaire} />
						<PrivateRoute exact path='/help' component={Help} />



						<PrivateRoute
							exact
							path='/update-profile'
							component={UpdateProfile}
						/>
					

						<PrivateRoute exact path='/preview/:id'>
							<Result />
						</PrivateRoute>

						<PrivateRoute exact path='/component/:id'>
						<MainPage />
						</PrivateRoute> 

						<PrivateRoute exact path='/finalresult/:id'>
						<FinalResult />
						</PrivateRoute> 
{/*
<PrivateRoute exact path='/component/:id'>
<MyComponent />
	</PrivateRoute> 

								<PrivateRoute exact path='/component/:id'>
								<MainPage />
								</PrivateRoute>
*/}
						<PrivateRoute exact path='/update/:id'>
							<UpdateForm />
						</PrivateRoute>

						<PrivateRoute exact path='/formular/:id'>
							<DisplayId />
						</PrivateRoute>
						<PrivateRoute exact path='/dashboard'>
							<Dashboard />
						</PrivateRoute>

						<Route exact path='/' component={Login} />

						<Route exact path='/signup' component={Signup} />
						<Route exact path='/forgot-password' component={ForgotPassword} />
					</Switch>
				</AuthProvider>
			</div>
		</div>
	);
}

export default App;

